/***
 * Model that represents Queue Notification
 */
import Backbone from 'backbone';

var QueueCount = Backbone.Model.extend({
    urlRoot: '/device-service/devicemessage/message/count',

    backend: 'gcapi',

    parse: function(count) {
        this.set('count', count);
        this.trigger('add', this);
    },

    poll: function() {
        if (!this.fetching) {
            this.fetching = true;
            var that = this;
            this.fetch({
                add: true,
                success: function(collection) {
                    collection.fetching = false;
                },
                error: that.onPollingError
            });
        }
    },

    onPollingError: function(collection, response) {
        collection.fetching = false;
        collection.pollingEnabled = false;
        if (typeof console !== 'undefined' && typeof console.log !== 'undefined') {
            console.log(
                new Date().toString() + ' - ' + 'Error polling: ' + response.status + ' ' + response.statusText
            );
        }
    },

    isPollingEnabled: function() {
        return true;
    }
});

export default QueueCount;
